import { render, staticRenderFns } from "./StudentsRegistry.vue?vue&type=template&id=bf60374c&scoped=true&"
import script from "./StudentsRegistry.vue?vue&type=script&lang=js&"
export * from "./StudentsRegistry.vue?vue&type=script&lang=js&"
import style0 from "./StudentsRegistry.vue?vue&type=style&index=0&id=bf60374c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf60374c",
  null
  
)

export default component.exports